import UserProfile from "./UserProflie";

export default function MyAccount({ user_data }) {
    return (
        <UserProfile user_data={user_data} />
    )
}